import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { CardWithModalComponent } from '../../shared/components/card-with-modal/card-with-modal.component';
import { ModalModel } from '../../shared/models/core/modal.model';
import { DOCUMENT } from '@angular/common';
import { TermsService } from '../../shared/services/terms.service';
import { RedirectRoutesConstants } from '../../shared/global/redirectRoutes.contants'
import { LogService } from '../../shared/services/log.services';
import { UserService } from '../../shared/services/user.service';
@Component({
  selector: 'before-you-start',
  templateUrl: './before-you-start.component.html',
  styleUrls: ['./before-you-start.component.scss']
})

export class BeforeYouStartComponent implements OnInit {
  @ViewChild('beforeYouStartCard') private beforeYouStartCard!: CardWithModalComponent;

  private listModalInfos: ModalModel[] = new Array<ModalModel>();
  private cardDescription: string = "";
  private cardTitle: string = "";
  private cardSubTitle: string = "";
  private cardIcon: string = "";
  private buttonText: string = "";
  public spectrumID: string = "";
  constructor(@Inject(DOCUMENT) private document: Document, private termsService: TermsService,
    private userService: UserService,
    private logService: LogService) { }

  
  ngOnInit(): void {
    this.populateCard();
  }

  async buttonClick(event: string) {
    await this.userService.CreateOrUpdateSpectrumUser();
    this.document.location.href = RedirectRoutesConstants.WellbeingHubUrl;
  }
  populateCard() {
    this.listModalInfos = new Array<ModalModel>();
    this.cardSubTitle = "Bringing together a wide-ranging choice of articles, videos, podcasts and much more to support your wellbeing, fitness and nutritional needs.";
    this.cardTitle = "Your Wellbeing Hub";
    this.cardDescription = "Spectrum Life provide Wellbeing Hub on behalf of Benenden Health. <br/> Please read the following documents before you access these services:";
    this.cardIcon = "../../assets/Resources/icons/before-you-start-icon.png";

    this.buttonText = "Got It";

    var privacyCardModal = new ModalModel();
    privacyCardModal.title = "Privacy Policy for wellbeing hub service";
    privacyCardModal.closeText = "ok";
    privacyCardModal.openButtonText = "Read Privacy Policy";
    this.termsService.getPrivacyPolicy().subscribe(
      (data: string) => {
        privacyCardModal.content = data;
      },
      (error) => {
        this.logService.error("Could not retrieve Privacy Policy");
      });
    this.listModalInfos.push(privacyCardModal);

    var termsCardModal = new ModalModel();
    termsCardModal.title = "Terms of Use for wellbeing hub service";
    termsCardModal.closeText = "ok";
    termsCardModal.openButtonText = "Read Terms and Conditions";
    this.termsService.getTermsAndConditions().subscribe(
      (data: string) => {
        termsCardModal.content = data;
      },
      (error) => {
        this.logService.error("Could not retrieve Terms and Conditions");
      });

    this.listModalInfos.push(termsCardModal);
  }
}
